<template>
    <div class="pps-callback">
        <div class="pps-callback__title">{{ $t("contact_us") }}</div>
        <div
            class="pps-callback__info"
            v-if="
                $store.getters['globalvars/getShowContactPhone'] &&
                $store.getters['globalvars/getLang'] &&
                $store.getters['globalvars/getLang'] === 'ru'
            ">
            <a href="tel:+7 (499) 229-11-11">+7 (499) 229-11-11</a>
            <div class="color-text_3">09:00 - 21:00</div>
        </div>
        <a href="mailto:help@pps-office.com" class="pps-callback__mail">help@pps-office.com</a>
        <div class="social pps-callback__info">
            <SocialLinks customClass="short-margin" type="messenger" />
        </div>
    </div>
</template>
<script>
import SocialLinks from "@/components/SocialLinks.vue";

export default {
    name: "PPSCallBack",
    components: { SocialLinks },
};
</script>
<style lang="less">
.pps-callback {
    &__title {
        color: #a6a6a6;
        margin-bottom: 24px;
    }
    &__info {
        display: flex;
        + a {
            margin-top: 8px;
        }
        a {
            display: flex;
            align-items: center;
            margin-right: 8px;
            svg {
                margin-right: 8px;
            }
        }
    }
    &__mail {
        display: block;
        margin-bottom: 26px;
    }
    > .button {
        margin-top: 24px;
        max-width: 162px;
        @media @sm {
            max-width: unset;
        }
    }
}
</style>
